'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _animejs = require('animejs');

var _animejs2 = _interopRequireDefault(_animejs);

var _performance = require('../../global/helpers/performance');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileHeader = function () {
  function MobileHeader(element) {
    (0, _classCallCheck3.default)(this, MobileHeader);

    this.element = element;
  }

  (0, _createClass3.default)(MobileHeader, [{
    key: 'getElement',
    value: function getElement() {
      return this.element;
    }
  }, {
    key: 'getBody',
    value: function getBody() {
      return document.querySelector('body');
    }
  }, {
    key: 'getSearchForm',
    value: function getSearchForm() {
      var element = this.getElement();
      return element.querySelector('form[action="/search"]');
    }
  }, {
    key: 'getNav',
    value: function getNav() {
      var element = this.getElement();
      return element.querySelector('.js-nav');
    }
  }, {
    key: 'getNavTrigger',
    value: function getNavTrigger() {
      var element = this.getElement();
      return element.querySelector('.js-openNav');
    }
  }, {
    key: 'getAccount',
    value: function getAccount() {
      var element = this.getElement();
      return element.querySelector('.js-account--mobile');
    }
  }, {
    key: 'getTier1Links',
    value: function getTier1Links() {
      var element = this.getNav();
      return element.querySelectorAll('.js-tier1Link');
    }
  }, {
    key: 'getTier2Dropdowns',
    value: function getTier2Dropdowns() {
      var element = this.getNav();
      return element.querySelectorAll('.js-tier2');
    }
  }, {
    key: 'getTier2Links',
    value: function getTier2Links() {
      var element = this.getNav();
      return element.querySelectorAll('.js-tier2Link');
    }
  }, {
    key: 'dropdownIsClosed',
    value: function dropdownIsClosed(link) {
      return link.getAttribute('aria-expanded') === 'false';
    }
  }, {
    key: 'isMobile',
    value: function isMobile() {
      return window.innerWidth < 951;
    }
  }, {
    key: 'init',
    value: function init() {
      var _this = this;

      var element = this.getElement();
      var tier1Links = this.getTier1Links();
      var tier2Links = this.getTier2Links();
      var navTriggerEl = this.getNavTrigger();

      navTriggerEl.addEventListener('click', function () {
        _this.toggleNav();
      });

      var cartTriggerEl = element.querySelector('.js-openCart');
      cartTriggerEl.addEventListener('click', function () {
        window.cart.showCart();
        _this.closeNav();
      });

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = tier1Links[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          /*       link.addEventListener('click', (event) => {
                  if (this.isMobile()) {
                    event.preventDefault();
                  }
                  if(this.dropdownIsClosed(link)) {
                    this.openTier2Dropdown(link);
                  } else {
                    this.closeTier2Dropdown(link);
                    this.closeTier3Dropdowns();
                  }
                }); */

          var link = _step.value;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _loop = function _loop(_link) {
        _link.addEventListener('click', function (event) {
          if (_this.isMobile()) {
            event.preventDefault();
          }
          if (_this.dropdownIsClosed(_link)) {
            _this.openTier3Dropdown(_link);
          } else {
            _this.closeTier3Dropdown(_link);
          }
        });
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = tier2Links[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _link = _step2.value;

          _loop(_link);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      window.addEventListener('scroll', function () {
        if (window.scrollY > 100) {
          element.classList.add('is-scrolling');
        } else {
          element.classList.remove('is-scrolling');
        }
      });

      var searchForm = this.getSearchForm();
      if (searchForm) {
        searchForm.addEventListener('submit', function () {
          _this.closeNav();
        });
      }

      this.initTier2Desktop();
    }
  }, {
    key: 'toggleNav',
    value: function toggleNav() {
      var body = this.getBody();
      var navTriggerEl = this.getNavTrigger();
      var nav = this.getNav();
      var currentState = nav.getAttribute('aria-hidden') === 'true';
      nav.setAttribute('aria-hidden', !currentState);
      navTriggerEl.classList.toggle('active');
      body.classList.toggle('fixed');
    }
  }, {
    key: 'closeNav',
    value: function closeNav() {
      var body = this.getBody();
      var navTriggerEl = this.getNavTrigger();
      var nav = this.getNav();
      nav.setAttribute('aria-hidden', true);
      navTriggerEl.classList.remove('active');
      body.classList.remove('fixed');
    }
  }, {
    key: 'animateTier2',
    value: function animateTier2(completionFn) {
      var nav = this.getNav();
      var dropdown = nav.querySelector('.js-tier1');

      _animejs2.default.timeline({
        targets: dropdown,
        easing: 'easeInOutQuad',
        duration: 500
      }).add({
        opacity: 0,
        complete: completionFn
      }).add({
        opacity: 1
      });
    }
  }, {
    key: 'initTier2Desktop',
    value: function initTier2Desktop() {
      var dropdowns = this.getTier2Dropdowns();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = dropdowns[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var dropdown = _step3.value;

          dropdown.classList.add('is-loaded');
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: 'openTier2Dropdown',
    value: function openTier2Dropdown(link) {
      var nav = this.getNav();
      var dropdown = link.nextElementSibling;
      var account = this.getAccount();
      this.animateTier2(function () {
        account.classList.add('hidden');
        nav.classList.add('active');
        dropdown.classList.add('active');
        link.setAttribute('aria-expanded', 'true');
      });
    }
  }, {
    key: 'closeTier2Dropdown',
    value: function closeTier2Dropdown(link) {
      var nav = this.getNav();
      var dropdown = link.nextElementSibling;
      var account = this.getAccount();

      this.animateTier2(function () {
        account.classList.remove('hidden');
        nav.classList.remove('active');
        dropdown.classList.remove('active');
        link.setAttribute('aria-expanded', 'false');
      });
    }
  }, {
    key: 'openTier3Dropdown',
    value: function openTier3Dropdown(link) {
      var dropdown = link.parentElement.nextElementSibling;
      var animationSettings = {
        targets: dropdown,
        easing: 'easeInOutQuad',
        duration: 500
      };

      dropdown.classList.add('active');
      link.setAttribute('aria-expanded', 'true');
      animationSettings.maxHeight = dropdown.scrollHeight + 26;

      (0, _animejs2.default)(animationSettings);
    }
  }, {
    key: 'closeTier3Dropdown',
    value: function closeTier3Dropdown(link) {
      var dropdown = link.parentElement.nextElementSibling;
      var animationSettings = {
        targets: dropdown,
        easing: 'easeInOutQuad',
        duration: 500
      };

      dropdown.classList.remove('active');
      link.setAttribute('aria-expanded', 'false');
      animationSettings.maxHeight = 0;

      (0, _animejs2.default)(animationSettings);
    }
  }, {
    key: 'closeTier3Dropdowns',
    value: function closeTier3Dropdowns() {
      var tier2Links = this.getTier2Links();
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = tier2Links[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var link = _step4.value;

          this.closeTier3Dropdown(link);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  }]);
  return MobileHeader;
}();

exports.default = MobileHeader;